// Loads the Trustpilot TrustBox script only once a widget approaches the
// viewport, so the third-party JS never competes with the initial render.
// Pages without a widget never load it at all.

export default function trustpilotLoader() {
	const widgets = document.querySelectorAll('.trustpilot-widget');

	if (!widgets.length) {
		return;
	}

	let loaded = false;

	const load = () => {
		if (loaded) {
			return;
		}

		loaded = true;
		const script = document.createElement('script');
		script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
		script.async = true;
		document.head.appendChild(script);
	};

	if (!('IntersectionObserver' in window)) {
		load();
		return;
	}

	const observer = new IntersectionObserver((entries) => {
		if (entries.some((entry) => entry.isIntersecting)) {
			observer.disconnect();
			load();
		}
	}, { rootMargin: '400px' });

	widgets.forEach((widget) => observer.observe(widget));
}
